<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-card flat>

                <v-card-title :class="stepperMode ? 'title-label' : 'title-container'">
                    <v-icon color="#FFFFFF" large class="mr-3">mdi-credit-card-outline</v-icon>
                    {{ $t('payment.add_payment_method') }}
                </v-card-title>

                <v-card-text class="pb-1">
                    <v-text-field :rules="[v => !!v || $t('rules.required')]" solo v-model="holderName"
                                  color="secondary"
                                  :label="$t('common.name')" clearable hide-details class="mb-5"></v-text-field>
                    <div id="card-element"></div>
                </v-card-text>

                <v-card-text class="pt-3">
                    <v-slide-x-transition>
                        <v-alert v-show="!!error" border="left" type="error" :value="true">{{ error }}</v-alert>
                    </v-slide-x-transition>
                </v-card-text>

                <v-card-actions class="px-0 pb-0" v-if="!noSaveButton">
                    <v-btn
                        block depressed x-large
                        color="primary"
                        class="normal-btn black--text"
                        style="border-radius: 0 0 8px 8px"
                        :disabled="!complete || !holderName"
                        @click="send" :loading="loading"
                    >
                        <v-icon left>mdi-credit-card-plus-outline</v-icon>
                        {{ $t('common.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-col>
    </v-row>
</template>

<script>
import {mapState} from 'vuex'
import {loadStripe} from '@stripe/stripe-js';
import KimsaTextField from "@/components/common/inputs/KimsaTextField";

export default {
    name: "CardCreator",
    props: {
        noSaveButton: {
            type: Boolean,
            default: false
        },
        defaultName: {
            type: String,
            default: ''
        },
        stepperMode: {
            type: Boolean,
            default: false
        }
    },
    components: {KimsaTextField},
    data(vm) {
        return {
            holderName: '',
            stripe: null,
            card: null,
            error: '',
            loading: false,
            complete: false,
        }
    },
    async mounted() {
        const vm = this
        await vm.init()
        if(vm.defaultName) {
            vm.holderName = vm.defaultName
        } else if (vm.account && vm.account.name) {
            vm.holderName = vm.account.name
        }
    },
    methods: {
        async init() {
            const vm = this
            const stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
            vm.stripe = stripe
            const elements = stripe.elements();
            const card = elements.create('card', {style: vm.style});
            card.mount('#card-element');
            card.on('change', vm.onCardChange);
            vm.card = card

        },
        onCardChange(event) {
            const vm = this

            if (event.error) {
                return vm.error = event.error.message;
            }

            vm.error = '';
            vm.complete = event.complete
        },
        async send() {
            const vm = this
            vm.loading = true
            await vm.stripe.createPaymentMethod({
                type: 'card',
                card: vm.card,
                billing_details: {name: vm.holderName}
            }).then(function (result) {
                vm.loading = false
                if (result.error) {
                    // Inform the user if there was an error.
                    vm.error = result.error.message;
                } else {
                    // Send the token to your server.
                    vm.stripeTokenHandler(result);
                }
            });
        },
        stripeTokenHandler(token) {
            // console.log('card token created!', token)
            const vm = this
            vm.$emit('success', token)
        }
    },
    computed: {
        ...mapState(['account']),
        style() {
            return {
                base: {
                    color: '#32325d',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#aab7c4'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            }
        },
        payload(vm = this) {
            if (vm.complete) {
                return {
                    type: 'card',
                    card: vm.card,
                    billing_details: {name: vm.holderName}
                }
            } else {
                return null
            }
        }
    },
    watch: {
        account(val) {
            if (val) {
                this.holderName = val.name
            }
        },
        error(val) {
            if (val) {
                this.$emit('error', val)
            }
        },
        holderName(val) {
            if (!val) {
                this.$emit('error', val)
            }
        },
        payload(val) {
            this.$emit('cardData', val)
        }
    }
}
</script>

<style scoped>

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 3%), 0px 2px 2px 0px rgb(160 160 160 / 0%), 0px 1px 5px 0px rgb(0 0 0 / 8%);
}


.StripeElement {
    box-sizing: border-box;

    height: 48px;

    padding: 10px 12px;

    border: 1px solid transparent;
    border-radius: 4px;
    background-color: white;

    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
}

.StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
    border-color: #fa755a;
}

.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
}

.title-label {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 30px;
}

.label {
    font-size: 15px;
    color: #707070;
    margin-top: -8px;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
    margin-bottom: 40px;
}

</style>